import { ActiveFlag, useFlag } from '@automata/utils/hooks';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { SimpleCard } from 'components/Cards/SimpleCard';

export interface GatedContentProps {
  unleashFlag: ActiveFlag;
  children: React.ReactNode;
}

export const GatedContent = ({
  unleashFlag,
  children,
}: GatedContentProps): JSX.Element | null => {
  const isEnabled = useFlag(unleashFlag);

  if (!isEnabled) {
    // TODO: Replace with Isaac's brand spanking new (and better looking) card
    // after PR
    return (
      <Container maxWidth="xs">
        <Box paddingTop={6}>
          <SimpleCard title="This page is not enabled">
            <Typography>Please contact Automata</Typography>
          </SimpleCard>
        </Box>
      </Container>
    );
  }

  return <>{children}</>;
};
